export const getUrl = (url: string) => {
  if (url.includes("http")) {
    return url;
  }
  return `https://${url}`;
};
